import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M21.6 0H7.716C7.404 0 7.092 0.131974 6.864 0.347974L0.348 6.84001C0.12 7.06802 0 7.36797 0 7.69197L0 21.6C0 22.92 1.068 24 2.4 24H21.6C22.92 24 24 22.92 24 21.6V2.4C24 1.08 22.932 0 21.6 0ZM7.2 3.40803L8.028 2.58003C8.136 2.47203 8.292 2.4 8.448 2.4H16.8V6C16.8 6.66 16.26 7.2 15.6 7.2H8.4C7.74 7.2 7.2 6.66 7.2 6V3.40803ZM21.6 20.4C21.6 21.06 21.06 21.6 20.4 21.6H3.6C2.94 21.6 2.4 21.06 2.4 20.4V8.44797C2.4 8.29197 2.46 8.136 2.58 8.028L4.8 5.80803V7.2C4.8 8.52 5.88 9.6 7.2 9.6H16.8C18.12 9.6 19.2 8.52 19.2 7.2V2.4H20.4C21.06 2.4 21.6 2.94 21.6 3.6V20.4ZM19.2 13.2C19.2 13.86 18.66 14.4 18 14.4H6C5.34 14.4 4.8 13.86 4.8 13.2C4.8 12.54 5.34 12 6 12H18C18.66 12 19.2 12.54 19.2 13.2ZM19.2 18C19.2 18.66 18.66 19.2 18 19.2H6C5.34 19.2 4.8 18.66 4.8 18C4.8 17.34 5.34 16.8 6 16.8H18C18.66 16.8 19.2 17.34 19.2 18ZM8.256 4.8C8.256 4.14 8.796 3.6 9.456 3.6C10.116 3.6 10.656 4.14 10.656 4.8C10.656 5.46 10.116 6 9.456 6C8.796 6 8.256 5.46 8.256 4.8Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
